import { FormRow, socialLinksPrefixes } from 'framework';
import { IconName, TextInput } from 'dbi-pearl-ui-kit';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { SocialLinksSectionStyled } from './SocialLinksSection.styled';

const socials = [
    'Website',
    'YouTube',
    'Facebook',
    'Instagram',
    'TikTok',
    'Pinterest',
    'Google',
    'LoveStoriesTV',
];

const SocialLinksSection = (props) => {
    const { labels } = props;
    const { watch, getValues, setValue } = useFormContext();
    const [currentTarget, setCurrentTarget] = useState(null);
    const [
        websiteFieldName,
        youtubeFieldName,
        facebookFieldName,
        instagramFieldName,
        tikTokFieldName,
        pinterestFieldName,
        googleFieldName,
        loveStoriesTVFieldName,
    ] = [...socials];

    const cleanLink = (name, url) => {
        if (url) {
            const reduced = url.replace(/(^\w+:|^)\/\//, '');
            if (name) {
                if (name === websiteFieldName || name === googleFieldName) {
                    return reduced;
                } else if (name === youtubeFieldName) {
                    return reduced.match(/([^/]+)\/?$/)[0].replace(/\/+$/, '');
                } else {
                    return reduced
                        .match(/([^/]+)\/?$/)[0]
                        .replace(/^@/, '')
                        .replace(/\/+$/, '');
                }
            }
        }
        return url;
    };

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            setCurrentTarget(name);
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (currentTarget) {
            if (socials.includes(currentTarget)) {
                setValue(currentTarget, cleanLink(currentTarget, getValues(currentTarget)));
            }
        }
    }, [watch(currentTarget)]);

    return (
        <SocialLinksSectionStyled data-testid="social-links-section">
            <div className="link-row">
                <FormRow
                    columns={[
                        <TextInput
                            formFieldName={websiteFieldName}
                            startIcon={IconName.WEB}
                            preText={socialLinksPrefixes.website.displayText}
                            providedLabel={labels?.Website}
                        />,
                        <TextInput
                            formFieldName={loveStoriesTVFieldName}
                            startIcon={IconName.LOVE_STORIES_TV}
                            preText={socialLinksPrefixes.loveStoriesTV.displayText}
                            providedLabel={labels?.LoveStoriesTV}
                        />,
                    ]}
                />
            </div>
            <div className="link-row">
                <FormRow
                    columns={[
                        <TextInput
                            formFieldName={instagramFieldName}
                            startIcon={IconName.INSTAGRAM}
                            preText={socialLinksPrefixes.instagram.displayText}
                            providedLabel={labels?.Instagram}
                        />,
                        <TextInput
                            formFieldName={facebookFieldName}
                            startIcon={IconName.FACEBOOK}
                            preText={socialLinksPrefixes.facebook.displayText}
                            providedLabel={labels?.Facebook}
                        />,
                    ]}
                />
            </div>
            <div className="link-row">
                <FormRow
                    columns={[
                        <TextInput
                            formFieldName={pinterestFieldName}
                            startIcon={IconName.PINTEREST}
                            preText={socialLinksPrefixes.pinterest.displayText}
                            providedLabel={labels?.Pinterest}
                        />,
                        <TextInput
                            formFieldName={googleFieldName}
                            startIcon={IconName.GOOGLE}
                            preText={socialLinksPrefixes.google.displayText}
                            providedLabel={labels?.Google}
                        />,
                    ]}
                />
            </div>
            <div className="link-row">
                <FormRow
                    columns={[
                        <TextInput
                            formFieldName={youtubeFieldName}
                            startIcon={IconName.YOUTUBE}
                            preText={socialLinksPrefixes.youtube.displayText}
                            providedLabel={labels?.YouTube}
                        />,
                        <TextInput
                            formFieldName={tikTokFieldName}
                            startIcon={IconName.TIK_TOK}
                            preText={socialLinksPrefixes.tikTok.displayText}
                            providedLabel={labels?.TikTok}
                        />,
                    ]}
                />
            </div>
        </SocialLinksSectionStyled>
    );
};

export { SocialLinksSection };
